import React, { Component } from "react";
import axios from "axios";
import { connect } from "react-redux";
import { Redirect, withRouter } from "react-router-dom";

import Outlet from "./components/outletCard";
import LoadingCard from "./components/loading";

import FilterElement from "../layout/FilterElement";
import Pagination from "../layout/Pagination";

import { updateFilterElement } from "../../store/actions/filterElementAction";
import { signOut } from "../../store/actions/authAction";
import subDays from "date-fns/subDays";
import "./style.css";
import "./../layout/styles/filter.css";
import Footer from "../Footer/Footer";
import outletImg from "./outlets.svg";
import Dropdown from "../Admin/components/MDOTable/components/Dropdown/Dropdown";
import {
  CircularProgress,
  Collapse,
  Grow,
  IconButton,
} from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import FieldForceCard from "./components/FieldForceCard";
import Avatar from "@material-ui/core/Avatar";
import { format } from "date-fns";
import DateRangeIcon from "@material-ui/icons/DateRange";
import DateRangePicker from "../Shared/DateRangePicker";
import Draggable from "react-draggable";
import Dialog from "@material-ui/core/Dialog";
import { Button } from "react-materialize";
import AxiosClient from "../../Network/AxiosClient";

const mdo_types = [
  { name: "MAO", id: "MAO" },
  { name: "MDO", id: "MDO" },
  { name: "MMO", id: "MMO" },
  { name: "MDE", id: "MDE" },
];

const config_field_force = [
  { key: "call_outcome", title: "Call outcome" },
  { key: "zone_aware_upload_time", title: "Call time", type: "date" },
  { key: "outlet__name", title: "Outlet name" },
  { key: "outlet__wallet_no", title: "Wallet no" },
  { key: "bmcc__code", secondaryKey: "bmcc__name", title: "BMCC" },
  {
    key: "spot_code__code",
    secondaryKey: "spot_code__name",
    title: "Spot",
  },
];

const config_top_bar = [
  { key: "name", secondaryKey: "contact_number", title: "Field force" },
  { key: "mdo_type", secondaryKey: "status", title: "Type" },
  { key: "leave_day", title: "Leave day" },
  { key: "joining_date", title: "Joining date" },
  { key: "resigning_date", title: "Resigining date" },
  { key: "fse", secondaryKey: "fse_contact_number", title: "FSE" },
  { key: "agency", secondaryKey: "agency_id", title: "Agency" },
];

class FieldForce extends Component {
  constructor(props) {
    super(props);

    this.cancelToken = React.createRef(null);

    this.state = {
      outlets: null,
      total: null,
      limit: null,
      search_term: "",

      data_fetching: false,
      outlet_info: "",
      field_force_info: "",
      FieldForceList: [],
      FieldForceCallHistory: [],
      field_force: null,
      showCalender: false,
      clusters: [],
      regions: [],
      areas: [],
      territories: [],
      agencies: [],
      selected_option: {
        region: "",
        area: "",
        territory: "",
        agency: "",
        mdo_type: "",
      },
      fse: [],
      fetchingFieldForceList: false,
      dateRange: [
        {
          startDate: subDays(new Date(), 30),
          endDate: new Date(),
          key: "selection",
        },
      ],
    };
  }

  handleParamsForCallingHistory = () => {
    const id = new URLSearchParams(window.location.search).get("id");
    const start = new URLSearchParams(window.location.search).get("start")
      ? format(
          new Date(new URLSearchParams(window.location.search).get("start")),
          "yyyy-MM-dd"
        )
      : format(new Date(this.state.dateRange[0].startDate), "yyyy-MM-dd");
    const end = new URLSearchParams(window.location.search).get("end")
      ? format(
          new Date(new URLSearchParams(window.location.search).get("end")),
          "yyyy-MM-dd"
        )
      : format(new Date(this.state.dateRange[0].endDate), "yyyy-MM-dd");

    const params = new URLSearchParams();
    params.append("id", id);
    params.append("start", start);
    params.append("end", end);
    this.props.history.push({ search: params.toString() });

    if (id) this.getFieldForceCallHistory(id, start, end);
    this.setState({
      dateRange: [
        {
          startDate: new Date(start),
          endDate: new Date(end),
          key: "selection",
        },
      ],
    });
  };

  componentDidMount() {
    //this.set_data_set();
    this.handleParamsForCallingHistory();
    this.getMDOList();
    this.load("clusters", "clusters", "");
    this.load("regions", "regions", "");
    this.load("areas", "areas", "");
    this.load("territories", "territories", "");
    this.load("agency", "agencies", "");
  }

  load = (endpoint, key, query) => {
    var param = "";
    if (query !== "") param = "?" + query.substring(1);
    AxiosClient.get(
      `${process.env.REACT_APP_API_URL}/api/organizations/api/v1/${endpoint}${param}`
    )
      .then((res) => {
        this.setState({
          [key]: res.data.data,
        });
      })
      .catch((err) => console.log(err));
  };

  componentDidUpdate(prevProps) {
    if (
      this.props.currentPage !== prevProps.currentPage ||
      this.props.currentLimit !== prevProps.currentLimit
    )
      this.set_data_set();
  }
  toggleCalenderView = () => {
    this.setState((prevState) => ({ showCalender: !prevState.showCalender }));
  };
  // New function to handle search button click
  handleSearchButtonClick = (e) => {
    e.preventDefault();
    this.set_data_set();
  };

  onChangeFieldForce = (event, newValue) => {
    const params = new URLSearchParams();
    if (newValue) {
      params.append("id", newValue.id);
    } else {
      params.append("id", null);
      this.setState({ FieldForceCallHistory: [], field_force: null });
    }

    params.append(
      "start",
      format(new Date(this.state.dateRange[0].startDate), "yyyy-MM-dd")
    );
    params.append(
      "end",
      format(new Date(this.state.dateRange[0].endDate), "yyyy-MM-dd")
    );
    this.props.history.push({ search: params.toString() });
    if (newValue) {
      this.getFieldForceDetail(newValue.id);
      this.getFieldForceCallHistory(
        newValue.id,
        format(new Date(this.state.dateRange[0].startDate), "yyyy-MM-dd"),
        format(new Date(this.state.dateRange[0].endDate), "yyyy-MM-dd")
      );
    }
  };

  callBackDateRange = (item) => {
    this.setState({ dateRange: [item.selection] }, () => {
      const id = new URLSearchParams(window.location.search).get("id");
      const params = new URLSearchParams();
      params.append("id", id);
      params.append(
        "start",
        format(new Date(this.state.dateRange[0].startDate), "yyyy-MM-dd")
      );
      params.append(
        "end",
        format(new Date(this.state.dateRange[0].endDate), "yyyy-MM-dd")
      );
      this.props.history.push({ search: params.toString() });
      if (id)
        this.getFieldForceCallHistory(
          id,
          format(new Date(this.state.dateRange[0].startDate), "yyyy-MM-dd"),
          format(new Date(this.state.dateRange[0].endDate), "yyyy-MM-dd")
        );
    });
  };

  makeQueryForFieldForceListApiCall = () => {
    var query = "";
    Object.keys(this.state.selected_option).map((key) => {
      if (this.state.selected_option[key] !== "")
        query += this.state.selected_option[key];
    });

    return query;
  };

  getFieldForceDetail = (id) => {
    AxiosClient.get(
      `${process.env.REACT_APP_API_URL}/api/admin_panel/v1/mdo-list?id=${id}`,
      {
        cancelToken: this.cancelToken.current.token,
      }
    )
      .then((res) => this.setState({ field_force: res.data.data[0] }))
      .catch((e) => console.log(e));
  };

  getMDOList = () => {
    if (this.cancelToken.current) {
      // Cancel the previous API request
      this.cancelToken.current.cancel("Cancelled due to new input");
    }

    this.setState({ fetchingFieldForceList: true });

    // Create a new cancel token
    this.cancelToken.current = axios.CancelToken.source();
    //console.log(this.cancelToken);
    const query = this.makeQueryForFieldForceListApiCall();
    AxiosClient.get(
      `${process.env.REACT_APP_API_URL}/api/admin_panel/v1/mdo-list?page_index=0&page_size=10000&filter=yes${query}`,
      {
        cancelToken: this.cancelToken.current.token,
      }
    )
      .then((res) => {
        this.setState({ fetchingFieldForceList: false });
        //console.log(res.data.data.length);
        this.setState({ FieldForceList: res.data.data }, () => {
          const id = new URLSearchParams(window.location.search).get("id");

          if (id) {
            this.getFieldForceDetail(id);
            // const value = res.data.data.find((element) => element.id === id);
            // this.setState({ field_force: value });
          }
        });
      })
      .catch(() =>
        this.setState({
          data_fetching: false,
          fetchingFieldForceList: false,
        })
      );
  };

  getFieldForceCallHistory = (id, startDate, endDate) => {
    this.setState({
      data_fetching: true,
    });
    AxiosClient.get(
      `${process.env.REACT_APP_API_URL}/api/users/api/v1/${id}/calls?start_time=${startDate}&end_time=${endDate}`
    )
      .then((res) => {
        // console.log(res.data);
        this.setState({
          FieldForceCallHistory: res.data.data,
          data_fetching: false,
        });
      })
      .catch(() =>
        this.setState({
          data_fetching: false,
        })
      );
  };

  create_filter_elements = (filter, type) =>
    filter.map((item, index) => (
      <FilterElement
        key={index}
        {...item}
        selectedValue={this.props.filterElement}
        type={type}
      />
    ));

  handleFilterChange = (options, key) => {
    // console.log(options);
    this.setState({ fetching_table_data: true });

    let filter =
      options !== null
        ? options.map((option) => `&${key}=${option.id}`).join("")
        : "";

    this.setState(
      (prevState) => ({
        selected_option: { ...prevState.selected_option, [key]: filter },
      }),
      () => {
        this.filterChangeRoutine(filter, key);

        // this.loadFSE();
        // this.getData();
      }
    );
  };

  filterChangeRoutine = (query, key) => {
    this.getMDOList();
    switch (key) {
      case "clusters":
        this.load("regions", "regions", query);
        this.load("areas", "areas", query);
        this.load("territories", "territories", query);
        this.load("agency", "agencies", query);
        break;
      case "region":
        this.load("areas", "areas", query);
        this.load("territories", "territories", query);
        this.load("agency", "agencies", query);
        break;
      case "area":
        this.load("territories", "territories", query);
        this.load("agency", "agencies", query);
        break;
      case "territory":
        this.load("agency", "agencies", query);
        break;
      default:
        break;
    }
  };

  render() {
    const localUserToken = JSON.parse(localStorage.getItem("currUserToken"));
    if (!localUserToken) return <Redirect to="/signin" />;

    let current_time = Date.now().valueOf() / 1000;
    if (this.props.expiration < current_time) this.props.signOut();

    return (
      <div className="main-container" style={{ padding: 24, height: "100vh" }}>
        <div className="outlets" style={{ padding: 0, height: "100%" }}>
          <div className="page-header" style={{ justifyContent: "flex-start" }}>
            <div className="page-heading-search">
              {true && (
                <div className="page-heading">
                  Field force
                  <div className="page-sub-heading">
                    {this.state.FieldForceList.length} Field forces in Dexter
                    database
                  </div>
                </div>
              )}
              <form className="field-force-search-container">
                {/* <input
                  type="text"
                  className="search_outlet"
                  placeholder="Search by Field Force "
                  onChange={(e) =>
                    this.setState({
                      field_force_info: e.target.value,
                    })
                  }
                /> */}
                <div className="search-autocomplete-container">
                  <Autocomplete
                    disabled={this.state.FieldForceList.length === 0}
                    id="combo-box-demo"
                    options={this.state.FieldForceList}
                    getOptionLabel={(option) => option.name}
                    getOptionSelected={(option, value) =>
                      option.value === value.value
                    }
                    style={{ width: 300 }}
                    onChange={this.onChangeFieldForce}
                    onClose={() => console.log("close presed")}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        className="autocomplete-searchbox"
                        label={
                          this.state.fetchingFieldForceList
                            ? "Populating field force list"
                            : "Search a field force"
                        }
                        variant="filled"
                      />
                    )}
                  />
                  {
                    <div
                      className="progress"
                      style={{
                        borderRadius: "0px 0px 8px 8px",
                        margin: "0px",
                        backgroundColor: "#e2136e57",
                        marginTop: -3,
                        opacity: this.state.fetchingFieldForceList ? 1 : 0,
                      }}
                    >
                      <div
                        className="indeterminate"
                        style={{ backgroundColor: "#e2136e" }}
                      ></div>
                    </div>
                  }
                </div>
                <div
                  className="date-range-container-fieldforce"
                  onClick={this.toggleCalenderView}
                >
                  <IconButton
                    // onClick={(e) => {
                    //   e.stopPropagation();
                    //   this.toggleCalenderView;
                    // }}
                    style={{
                      backgroundColor: "transparent",

                      padding: 0,
                    }}
                  >
                    <DateRangeIcon />
                  </IconButton>
                  <p className="daterange-info">
                    <b className="daterange-info-bold">
                      {format(
                        new Date(this.state.dateRange[0].startDate),
                        "MMM dd, yyyy"
                      )}{" "}
                    </b>
                    to{" "}
                    <b className="daterange-info-bold">
                      {format(
                        new Date(this.state.dateRange[0].endDate),
                        "MMM dd, yyyy"
                      )}
                    </b>{" "}
                  </p>
                </div>
                <Dialog
                  open={this.state.showCalender}
                  onClose={this.toggleCalenderView}
                >
                  <div className="date-range-modal">
                    <DateRangePicker
                      dateRange={this.state.dateRange}
                      onChangeDateRange={this.callBackDateRange}
                    />
                    {/* <Button className="date-range-modal-button">Search</Button> */}
                  </div>
                </Dialog>
              </form>
            </div>
            <div className="page-settings"></div>
          </div>
          <div className="grouped-filter-search">
            {" "}
            <div className="filter-by-agency">
              <Dropdown
                title="Filter By MDO type"
                items={mdo_types}
                multiselect
                onChange={(options) =>
                  this.handleFilterChange(options, "mdo_type")
                }
              />
            </div>
            <div className="filter-by-agency">
              <Dropdown
                title="Filter By Circle"
                items={this.state.clusters}
                multiselect
                onChange={(options) =>
                  this.handleFilterChange(options, "clusters")
                }

                //onChange={this.handleMDOTypeChange}
              />
            </div>
            <div className="filter-by-agency">
              <Dropdown
                title="Filter By Zone"
                items={this.state.regions}
                multiselect
                onChange={(options) =>
                  this.handleFilterChange(options, "region")
                }

                //onChange={this.handleMDOTypeChange}
              />
            </div>
            <div className="filter-by-agency">
              <Dropdown
                title="Filter By Area"
                items={this.state.areas}
                multiselect
                onChange={(options) => this.handleFilterChange(options, "area")}

                //onChange={this.handleMDOTypeChange}
              />
            </div>
            <div className="filter-by-agency">
              <Dropdown
                title="Filter By Territories"
                items={this.state.territories}
                multiselect
                onChange={(options) =>
                  this.handleFilterChange(options, "territory")
                }

                //onChange={this.handleMDOTypeChange}
              />
            </div>
            <div className="filter-by-agency">
              <Dropdown
                title="Filter By Agencies"
                items={this.state.agencies}
                multiselect
                onChange={(options) =>
                  this.handleFilterChange(options, "agency")
                }

                //onChange={this.handleAgencyChange}
              />
            </div>
          </div>
          <Collapse in={this.state.field_force ? true : false}>
            {this.state.field_force && (
              <FieldForceInfo info={this.state.field_force} />
            )}
          </Collapse>

          <Pagination
            page={"outlets"}
            currentPage={this.props.currentPage}
            total={this.state.total}
            limit={this.props.currentLimit}
          />
          {this.state.FieldForceCallHistory.length === 0 &&
            this.state.field_force && (
              <h3 className="blank-call-history">No call history found</h3>
            )}
          {this.state.FieldForceCallHistory.length > 0 ? (
            <div className="field-force-card-container">
              {this.state.FieldForceCallHistory.map((item, index) => (
                <FieldForceCard
                  info={item}
                  key={index}
                  config={config_field_force}
                />
              ))}
            </div>
          ) : (
            <div className="placeholder-image-container">
              <img src={outletImg} alt="outlet" />
            </div>
          )}

          <Pagination
            page={"outlets"}
            currentPage={this.props.currentPage}
            total={this.state.total}
            limit={this.props.currentLimit}
          />
        </div>
      </div>
    );
  }
}

const FieldForceInfo = ({ info }) => {
  const config = config_top_bar;
  const formatedJoinDate = format(new Date(info.joining_date), "MMM dd, yyyy");

  info = {
    ...info,
    joining_date: formatedJoinDate,
  };

  return (
    <div className="top-bar-fieldforce">
      {info && (
        <div className="info avatar">
          <Avatar src={info.image} style={{ background: "#e2136e" }} />
        </div>
      )}
      {config &&
        info &&
        config.map((item) => (
          <div className="info" key={item.title}>
            <div>
              <p>{item.title}</p>
              {info[item.key] ? (
                <h2 className="primary">{info[item.key]}</h2>
              ) : (
                <h2 className="primary not-available">Not available</h2>
              )}
              <h2 className="secondary">
                {item.secondaryKey && info[item.secondaryKey]}
              </h2>
            </div>
          </div>
        ))}
    </div>
  );
};

const mapStateToProps = (state) => {
  let currentPage = state.page.outlets
    ? state.page.outlets.currentPage
    : state.page.default.currentPage;

  let currentLimit = state.paginationLimit.outlets
    ? state.paginationLimit.outlets.currentLimit
    : 12;

  let expiration = state.auth.authToken
    ? state.auth.authToken.expiration
    : 20000;

  let portal = state.auth.authToken ? state.auth.authToken.portal : "dexter";

  return { currentPage, currentLimit, expiration, portal };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateFilterElement: (filter) => dispatch(updateFilterElement(filter)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(FieldForce)
);
